import React, { useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import authContext from '../../../../../AuthContext/authContext';
import MainNavigation from '../../MainNavigation';
import Footer from '../../Footer/Footer';
import StaffSessionGate from './StaffSessionGate';

// Recovery/public landing routes are not privileged staff workspaces. Their
// availability is not staff authorization; private APIs retain the server gate.
const recoveryRoutes = new Set(['/', '/home', '/login', '/signup', '/verify', '/forgotpassword', '/forgot-password']);
export const requiresStaffSession = pathname => !recoveryRoutes.has(pathname.toLowerCase());

function RecoveryShell({ children }) {
  const auth = useContext(authContext);
  // Never mount authenticated navigation actions or selected-account data while
  // verification is pending. Keep public links and the ordinary footer usable.
  const publicAuth = { ...auth, token: null, userId: null, username: null, email: null,
    role: null, isVerified: false, summaryData: null, tempRole: null, tempUsername: null, tempEmail: null };
  return <authContext.Provider value={publicAuth}>
    <MainNavigation />
    {children}
    <Footer />
  </authContext.Provider>;
}

export default function StaffSessionBoundary({ children }) {
  const location = useLocation(), history = useHistory();
  return <StaffSessionGate protectedRoute={requiresStaffSession(location.pathname)}
    fallbackShell={content => <RecoveryShell>{content}</RecoveryShell>}
    onSignedOut={() => history.replace('/login')}>
    {children}
  </StaffSessionGate>;
}
